<template>
  <div
    class="flex w-full flex-col gap-48 md:flex-row"
    :class="{ 'justify-center': !shouldDisplayRightColumn }"
  >
    <ExpectedProduct
      :breadcrumb="breadcrumb"
      class="w-full md:w-1/2"
      :is-loading="shouldDisplaySkeleton"
      :product="product"
      :rating="rating"
      :recommendation="alternative"
    />

    <div v-if="shouldDisplayRightColumn" class="w-full md:w-1/2">
      <AlternativeSkeleton v-if="shouldDisplaySkeleton" class="size-full" />
      <AlternativeProduct v-if="alternative" :recommendation="alternative" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { productAPI } from '@backmarket/http-api'
import type { Rating } from '@backmarket/http-api/src/api-specs-reviews/types/rating'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import type { Product } from '~/scopes/core/models/product'

import AlternativeProduct from './components/AlternativeProduct/AlternativeProduct.vue'
import AlternativeSkeleton from './components/AlternativeSkeleton/AlternativeSkeleton.vue'
import ExpectedProduct from './components/ExpectedProduct/ExpectedProduct.vue'

const props = withDefaults(
  defineProps<{
    breadcrumb: productAPI.GetBreadcrumbResponse | null
    product: productAPI.GetProductResponse
    rating?: Rating
    alternative: Product | null
    isAlternativeLoading: boolean
  }>(),
  {
    rating: () => ({ averageRate: 0, count: 0 }),
  },
)

const shouldDisplaySkeleton = computed(() => {
  return props.isAlternativeLoading === true
})

const shouldDisplayAlternative = computed(() => {
  return !isEmpty(props.alternative)
})

const shouldDisplayRightColumn = computed(() => {
  return shouldDisplaySkeleton.value || shouldDisplayAlternative.value
})
</script>
